import React, { useEffect, useState, useCallback } from 'react';
import Pagination from '../../../Utilities/Pagination';
import { post } from '../../Auths/AuthToken';
import CredentialingList from './CredentialingList';
import Button from '../../Button';
import CredentialingPopup from './CredentialingPopup';
import setUiMessage from '../../../Utilities/Tostify';
import Select from 'react-select';

function Index() {
  const [payer, setPayer] = useState({
    id: 'All',
    value: 'All',
    payer_name: 'All Payers',
    label: 'All Payers',
  });
  const [renPro, setRenPro] = useState({
    id: 'All',
    value: 'All',
    billing_provider_name: 'All Ren. Providers',
    label: 'All Ren. Providers',
  });
  const [allData, setAllData] = useState([]);
  const [toggleGrid, setToggleGrid] = useState(true);
  const [openAddPopup, setOpenAddPopup] = useState(false);
  const [reload, setReload] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(200);

  const handlePageChange = useCallback((data) => {
    setOffset(data[0]);
    setLimit(data[1]);
  }, []);

  const handlePayerChange = (option) => {
    setPayer(option);
    setOffset(0);
  };

  const handleRenProChange = (option) => {
    setRenPro(option);
    setOffset(0);
  };

  // Fetch data only when relevant dependencies change
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await post(
          'api/reports/managePayerMatrix/payerMatrixList',
          { RenderProvider: renPro?.value, payer: payer?.value, offset, limit }
        );
        if (response.status === 200) {
          setAllData(response?.data);
        }
      } catch (err) {
        setUiMessage('err', err?.message);
      }
    };

    fetchData();
  }, [renPro, payer, offset, limit, reload]);


  return (
    <div id="preauthMaingrid" className="preauth-Maingrid-Pat doc-main-grid">
      <div className="intake-mid-bdy-hdr">
        <span
          className="widget-hdr-title bold clear-top"
          style={{ color: 'white' }}
        >
          Credentialing:
        </span>
      </div>

      <div className="bill-dt-main-con">
        <div className="bill-days-blk">
          <span className="intake-head-inpt-main">
            <span className="intake-head-inpt-sec">
              {/* <select
                  className="inpt-width-nw"
                  value={payer}
                  onChange={(e) => setPayer(e.target.value)}
                >
                  {allData?.payerListArr?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.payer_name}
                    </option>
                  ))}
                </select> */}
              <Select
                value={payer}
                options={allData?.payerListArr}
                onChange={handlePayerChange}
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </span>

            <span className="intake-head-inpt-sec">
              {/* <select
                  className="inpt-width-nw"
                  value={renPro}
                  onChange={(e) => setRenPro(e.target.value)}
                >
                  {allData?.billProvArr?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.billing_provider_name}
                    </option>
                  ))}
                </select> */}
              <Select
                value={renPro}
                options={allData?.billProvArr}
                onChange={handleRenProChange}
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </span>
          </span>
        </div>
        <Button
          text="Add New"
          variant="primary"
          onClick={() => setOpenAddPopup(true)}
        />
      </div>

      <div className="intake-paging">
        <Pagination
          totalRecord={(allData && Number(allData?.totalCount)) || 0}
          onPageChange={handlePageChange}
          offset={offset}
          rowPerPage={limit}
        />
      </div>

      <div className="docMaingrid-Patbdy grid-sec">
        <div className="intake-Maingrid-Pat-hdr grid-sec">
          <div className="docMaingrid-Pat-sbhdr flex-sec">
            <span className="pacolm1" style={{ width: 'calc(3% - 0px)' }}>
              <span
                className="collapse-icon"
                onClick={() => setToggleGrid(!toggleGrid)}
              >
                {toggleGrid ? '-' : '+'}
              </span>
            </span>
            <span className="pacolm4">Payer Name</span>
            <span className="pacolm5">Credentialing</span>
            <span className="pacolm5">Effective</span>
            <span className="pacolm5">EDI</span>
            <span className="pacolm5">ERA</span>
            <span className="pacolm5">EFT</span>
            <span className="pacolm5">Portal</span>
            <span className="pacolm4">Action</span>
          </div>
        </div>
        <div className="intake-Maingrid-Pat-sb-bdy qgrid-sec">
          {allData?.payerMatrixListArr?.map((item, i) => (
            <div
              key={i}
              className={
                i % 2 === 0
                  ? 'preauth-Maingrid-Pat-bdy-rw flex-sec alt-rw'
                  : 'preauth-Maingrid-Pat-bdy-rw flex-sec'
              }
            >
              <CredentialingList
                key={toggleGrid}
                item={item}
                ptoggleGrid={toggleGrid}
                reload={() => setReload(!reload)}
                payerPlanList={allData?.payerPlanList}
              />
            </div>
          ))}
        </div>
      </div>
      {openAddPopup && (
        <CredentialingPopup
          close={() => setOpenAddPopup(false)}
          reload={() => setReload(!reload)}
        />
      )}
    </div>
  );
}

export default Index;
